import React from 'react';
import { Layout } from 'antd'
import BaseHeader from './components/BaseHeader'
import BaseContent from './components/BaseContent'
import './index.css'
import Header4 from '../../../Header/Header4';
import Navigator from '../../../Navigator'

/**
 * 知识库 主页面
 */
class Repository extends React.Component {

    state = {
        isMore: false
    }

    // 用于子组件 "传值给" 父组件的数据
    getChildrenMsg = (result, msg) => {
        // debugger
        this.setState({
            isMore: !msg
        })
        // alert(this.state.isMore)
    }

    render() {
        return (
            <>
            <Header4 />
            <Layout>
                <Layout.Header className={this.state.isMore ? "base-header-show" : "base-header-hidden"}>
                    <BaseHeader parent={this} />
                </Layout.Header>
                <Layout.Content >
                    <BaseContent isMore={this.state.isMore}/>
                </Layout.Content>
            </Layout>
            <Navigator />
            </>
        );
    }
}


export default Repository